import { network } from './network';

export async function sendMessage(opts) {
	const res = await network({
		url: '/api/v1/send_message',
		method: 'post',
		params: {
			session_id: opts.session_id,
			reply_message_id: opts.reply_message_id,
			contents: opts.contents
		},
		headers: {
			token: opts.token,
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function getBotReplyMessage(opts) {
	const res = await network({
		url: '/api/v1/buffered_res',
		method: 'post',
		params: {
			session_id: opts.session_id,
			reply_message_id: opts.reply_message_id,
		},
		headers: {
			token: opts.token,
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function getSessionInfo(opts) {
	const res = await network({
		url: '/api/v1/session_info',
		method: 'post',
		params: {
			role_id: opts.role_id,
			session_id: opts.session_id
		},
		headers: {
			token: opts.token
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function getSessionAllMessages(opts) {
	const res = await network({
		url: '/api/v1/chat_messages_all',
		method: 'post',
		params: {
			session_id: opts.session_id
		},
		headers: {
			token: opts.token
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function getSessionList(opts) {
	const res = await network({
		url: '/api/v1/web/session_list',
		method: 'post',
		params: {},
		headers: {
			token: opts.token
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}
